import React from "react";
import AuthenticationComponent from "./authentication.component";
import { useSelector } from "react-redux";

export default function AuthenticationContainer({
  id,
  currentLanguage,
  isTemplateEditor,
  getTranslation,
}) {
  const { isVisible, content } = useSelector((state) =>
    isTemplateEditor
      ? state.products.template.workspaceSetting.setting.components[id]
      : state.productPage.components[id]
  );
  const isSnHidden = content.isSnHidden ?? false;
  const { productName, picture } = useSelector((state) => state.productPage);
  const userLanguage = useSelector((state) => state.profile.language);
  const message = content.messages.find(
    (e) => e.lang === currentLanguage
  ).value ?? content.messages[0]?.value ?? "";
  const companyId = useSelector((state) => state.profile.companyID);

  return (
    isVisible && (
      <AuthenticationComponent
        isSnHidden={isSnHidden}
        productName={productName}
        picture={picture}
        content={content}
        message={message}
        userLanguage={userLanguage}
        companyId={companyId}
        currentLanguage={currentLanguage}
        getTranslation={getTranslation}
      />
    )
  );
}
